import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios' 
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import global from './utils/global'


// 引入腾讯地图路线规划
import { cb } from './utils/cb';
window.cb = cb
import { display_polyline } from './utils/cb';
window.display_polyline = display_polyline

// import vconsole from 'vconsole'
// const vConsole = new vconsole();
// Vue.use(vConsole)


Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.axios = axios;
Vue.prototype.global = global

store.$global = global;
import { loadAMap } from './utils/amap-loader'
loadAMap().catch(() => { ElementUI.Message.warning('地图暂不可用，请稍后刷新；其他功能仍可使用') }).then(() => new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app'))
import './utils/amap-mapkit'
